export default "__VITE_ASSET__D_yYW339__"